/**
 * Represents Represents a sub-view in the UI view customization.
 */
export default class CustomSubUIView {
  /**
   * Gets or sets Caption.
   */
  caption?: (string | null | undefined)

  /**
   * Gets or sets Children.
   */
  children?: (CustomSubUIView[] | null | undefined)

  /**
   * Gets or sets Expanded.
   */
  expanded = false;

  /**
   * Gets or sets Is grid properties visible.
   */
  isGridPropertiesVisible = true;

  /**
   * Gets or sets Name.
   */
  name = '';

  /**
   * Gets or sets Relation path.
   */
  relationPath: string[]

  /**
   * Gets or sets Selected.
   */
  selected = false;
}